import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@breakroom-nx/redux';
import { Coordinate } from '@breakroom-nx/helpers';

interface BoundsState {
  currentBounds?: Coordinate;
}

const initialState: BoundsState = {
  currentBounds: undefined,
};

export const boundsSlice = createSlice({
  name: 'bounds',
  initialState,
  reducers: {
    setBounds: (state, action: PayloadAction<any>) => {
      const newBounds: Coordinate = action.payload;
      // console.log(
      //   `Selected Bounds: [${newBounds.latitude}, ${newBounds.longitude}]`
      // );
      state.currentBounds = newBounds;
    },
  },
});

export const { setBounds } = boundsSlice.actions;
export const getCurrentBounds = (state: RootState) =>
  state.bounds.currentBounds;
export default boundsSlice.reducer;
